(() => {
  if (customElements.get('luveon-cart-suggestion')) return;
  class FittaBellaCartSuggestion extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.quantity = Number(this.dataset.quantity) === 2 ? 2 : 1;
      this.label = key => this.dataset[key] || '';
      this.addedText = () => this.label(this.quantity === 2 ? 'addedTwo' : 'addedOne');
      this.toggle = this.querySelector('[data-lv-suggestion-toggle]');
      this.picker = this.querySelector('[data-lv-suggestion-picker]');
      this.addButton = this.querySelector('[data-lv-suggestion-add]');
      this.status = this.querySelector('[data-lv-suggestion-status]');
      this.selects = [...this.querySelectorAll('[data-lv-suggestion-option]')];
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        event.preventDefault(); event.stopPropagation();
        if (button === this.toggle) this.expand();
        if (button === this.addButton) this.add();
      }, { signal:this.abort.signal });
      this.addEventListener('change', event => {
        if (!this.selects.includes(event.target)) return;
        event.stopPropagation();
        this.selectVariant();
      }, { signal:this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
    message(text) { this.status.textContent = text; this.status.hidden = !text; }
    async expand() {
      if (this.pending) return;
      const opening = this.picker.hidden;
      this.picker.hidden = !opening;
      this.toggle.setAttribute('aria-expanded', String(opening));
      this.toggle.textContent = opening ? this.label('close') : this.label('add');
      if (!opening) return;
      if (!this.variants) {
        this.pending = true; this.toggle.disabled = true;
        this.message(this.label('loading'));
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'products/' + encodeURIComponent(this.dataset.handle) + '.js', { headers:{Accept:'application/json'}, credentials:'same-origin' });
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          if (!Array.isArray(product.variants)) throw new Error('Invalid product');
          this.variants = product.variants;
          const first = this.variants.find(v => v.available);
          if (first) this.selects.forEach((select,index) => { select.value = first.options[index]; });
        } catch {
          this.message(this.label('loadError'));
          this.pending = false; this.toggle.disabled = false; return;
        } finally { this.pending = false; this.toggle.disabled = false; }
      }
      this.selectVariant(); this.selects[0]?.focus();
    }
    selectVariant() {
      if (!this.variants) return;
      const prefix = [];
      this.selects.forEach((select,index) => {
        const candidates = this.variants.filter(v => v.available && prefix.every((value,i) => v.options[i] === value));
        [...select.options].forEach(option => { option.disabled = !candidates.some(v => v.options[index] === option.value); });
        if (candidates.length && !candidates.some(v => v.options[index] === select.value)) select.value = candidates[0].options[index];
        prefix.push(select.value);
      });
      this.variant = this.variants.find(v => v.available && this.selects.every((select,index) => v.options[index] === select.value));
      this.addButton.disabled = !this.variant;
      if (this.variant) {
        this.querySelector('[data-lv-suggestion-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
          style:'currency', currency:this.dataset.currency || 'EUR'
        }).format(this.variant.price / 100) + ' ' + this.label('perItem');
        const image = this.querySelector('[data-lv-suggestion-image]');
        if (image && this.variant.featured_image?.src) image.src = this.variant.featured_image.src;
        this.message('');
      } else this.message(this.label('unavailable'));
    }
    lock(drawer, value) {
      this.pending = value;
      this.setAttribute('aria-busy', String(value));
      if (value) {
        this.controls = [...new Set([...(drawer?.querySelectorAll('input, select, textarea, button') || []), ...this.querySelectorAll('input, select, button')])]
          .filter(el => !el.classList.contains('drawer__close'))
          .map(el => ({el,disabled:el.disabled}));
        this.controls.forEach(({el}) => { el.disabled = true; });
      } else this.controls?.forEach(({el,disabled}) => { el.disabled = disabled; });
    }
    render(drawer, sections) {
      const html = sections?.['cart-drawer'];
      if (!html || !drawer) return false;
      const parsed = new DOMParser().parseFromString(html,'text/html');
      const next = parsed.querySelector('#CartDrawer .drawer__inner');
      const current = drawer.querySelector('.drawer__inner');
      if (!next || !current) return false;
      current.replaceWith(next);
      drawer.classList.remove('is-empty');
      drawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
      if (sections['cart-icon-bubble']) {
        const icon = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
        const existing = document.getElementById('cart-icon-bubble');
        if (icon && existing) existing.innerHTML = icon.innerHTML;
      }
      const region = next.querySelector('#CartDrawer-LiveRegionText');
      if (region) region.textContent = this.addedText();
      if (typeof trapFocus === 'function') trapFocus(next,next.querySelector('.drawer__close') || next);
      return true;
    }
    async add() {
      if (this.pending || !this.variant) return;
      const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
      if (drawer?.querySelector('luveon-discount[aria-busy="true"]')) return;
      this.lock(drawer,true); this.message(this.label(this.quantity === 2 ? 'addingTwo' : 'addingOne'));
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const response = await fetch(root + 'cart/add.js', {
          method:'POST', credentials:'same-origin', headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify({ items:[{id:this.variant.id,quantity:this.quantity}], sections:['cart-drawer','cart-icon-bubble'], sections_url:window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok) { this.message(result.description || this.label('stockError')); return; }
        added = true;
        let sections = result.sections;
        if (!sections?.['cart-drawer']) {
          const refresh = await fetch(root + '?sections=cart-drawer,cart-icon-bubble', {credentials:'same-origin',cache:'no-store'});
          if (refresh.ok) sections = await refresh.json();
        }
        if (!this.render(drawer,sections)) {
          this.message(this.addedText() + ' ' + this.label('refresh'));
          this.addedWithoutRefresh = true;
        }
      } catch {
        this.message(added ? this.addedText() + ' ' + this.label('refresh') : this.label('retryError'));
        if (added) this.addedWithoutRefresh = true;
      } finally {
        this.lock(drawer,false);
        if (this.addedWithoutRefresh) this.addButton.disabled = true;
      }
    }
  }
  customElements.define('luveon-cart-suggestion',FittaBellaCartSuggestion);
})();

